import styled from "styled-components";
import {BackTableField} from "../../../features/schemaManageSlice";
import {useAppDispatch, useAppSelector} from "../../../hooks";
import hljs from "highlight.js/lib/core";
import React, {useState} from "react";
import {headerTypesIcons, schemas} from "../../../config";
import {Field, FIELD_TYPE_INFO} from "../../../Types";
import {FontAwesomeTypeIcon} from "../../misc/TypeIcon";
import {getReadableTextColor} from "../../filters/FilterMultiMapValue";
import {faCheck, faEdit, faPlus, faQuestion, faTriangleExclamation, faXmark} from "@fortawesome/free-solid-svg-icons";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {SqlQuery} from "./BackTableFieldViewTable";
import EditJoin from "./edit/EditJoin";

interface BackTableFieldPropsI {
    tableName: string,
    joinKey: string,
    join: string,
    index: number,
}

type FieldItemTypeU = "static" | "ethereal" | "other";

type FieldItemViewPropsI = {
    joinKey: string,
    join: string,
    index: number,
    type: FieldItemTypeU,
    editable?: boolean,
};

export default function BackTableJoinViewTable({tableName, joins}: {
    tableName: string,
    joins: Record<string, string>
}) {


    return <Container>
        <table>
            <thead>
            <tr>
                <th>Ключ</th>
                <th>SQL</th>
                <th>#</th>
            </tr>
            </thead>
            <tbody>
            {Object.entries(joins).map(([key, join], i) =>
                <BackTableJoinView tableName={tableName} key={key} index={i} joinKey={key} join={join}/>)}
            </tbody>
        </table>
    </Container>
}

function BackTableJoinView({
                               tableName,
                               joinKey,
                               join,
                               index,
                           }: BackTableFieldPropsI) {

    const staticTable = useAppSelector(state => state.schemaManage.back.staticTables[tableName]);
    const staticJoin = staticTable !== null && staticTable.joins[joinKey]
    const etherealTable = useAppSelector(state => state.schemaManage.back.etherealTables[tableName]);
    const etherealJoin = etherealTable !== null && etherealTable.joins[joinKey]
    const mode = useAppSelector(state => state.schemaManage.back.mode);
    const project = useAppSelector(state => state.project.name);

    return <>
        {mode === "edit" && staticJoin &&
            <JoinItemView join={staticJoin} type={"static"} joinKey={joinKey} index={index}/>}
        {mode === "edit" && etherealJoin &&
            <JoinItemView join={etherealJoin} editable type={"ethereal"} joinKey={joinKey} index={index}/>}
        {mode === "view" && join &&
            <JoinItemView join={join} type={"other"} joinKey={joinKey} index={index}/>}
    </>
}

function JoinItemView({
                          index,
                          joinKey,
                          type,
                          editable = false,
                          join
                      }: FieldItemViewPropsI) {
    // <FieldItemStyled $hasSql={!!sqlQuery} $type={type}>

    const [isEditing, setIsEditing] = useState(false)
    const closeEditing = () => setIsEditing(false);

    return <>
        <tr className={"title"}>
            <td className={'key'}>
                <div className="cont">
                    <span>{joinKey}</span>
                    {editable && <button className={'edit-backtable-field btn-cmn'} onClick={() => setIsEditing(true)}>
                        <FontAwesomeIcon size={"lg"} icon={faEdit} className={'fa-secondary-color-text'}/>
                    </button>}
                </div>
                {isEditing && <EditJoin join={join} joinKey={joinKey} closeEditing={closeEditing}/>}
            </td>
            <td className="sql">
                <div className="sql-cont">
                   <SqlQuery sqlQuery={join}/>
                </div>
            </td>
            <td className={"index"}>{type === "static" && <i>STATIC |&nbsp;</i>}{index + 1}</td>
        </tr>
    </>
}


const Container = styled.div`
    //display: flex;
    //flex-direction: column;
    //gap: .5rem;
    width: 100%;
    //max-width: 100%;
    padding: .4rem;
    border-radius: .2rem;
    background-color: var(--table-header-bg-color);
    //border-collapse: separate;
    overflow-x: auto;

    .add-new {
        display: inline-flex;
        gap: .5rem;
        align-items: center;
        justify-content: space-between;

        & button {
            padding: 0;
            appearance: none;
            border: none;
            background: none;
        }
    }

    table {
        table-layout: auto;
        width: 100%;
        border: 1px solid var(--table-border-color);

        th, td {
            vertical-align: middle;
            padding: .4rem .2rem;
            line-height: 1.2;
            border-bottom: 2px solid var(--table-border-color);
            border-right: 2px solid var(--table-border-color);
            border-left: 2px solid var(--table-border-color);
            border-top: 2px solid var(--table-border-color);

        }

        th {
            text-align: center;
            white-space: nowrap;
        }
    }

    tbody {
        max-width: 100%;
        overflow-x: auto;

        & > tr {
            max-width: 100%;
            width: 100%;
            overflow-x: auto;
        }

    }

    .present {
        text-align: center;
    }

    .content {
        width: 100%;
    }

    .title {

        line-height: 1;

        .icon {
            //width: 1.25rem;
            //display: flex;
            //align-items: center;
            //justify-content: center;
            width: 1%;
            text-align: center;
        }

        .key {
            width: 1%;
            text-align: left;
            white-space: nowrap;
            padding-right: .4rem;
            padding-left: .4rem;


            .cont {
                display: inline-flex;
                gap: .5rem;
                align-items: center;

                & button {
                    padding: .2rem;
                }
            }
        }

        .front-type {
            padding: .2rem .4rem;
            border-radius: .2rem;
            //width: fit-content;
            width: 100%;
            white-space: nowrap;
            display: inline-block;
            //height: 3rem;
            //width: 100%;
        }

        .missing {
            //background-color: #62615c;
            //color: yellow;
            //padding: .2rem .4rem;
            //border-radius: .2rem;
        }
    }

    .index {
        min-width: 30px;
        width: 1%;
        text-align: center;
        white-space: nowrap;
    }

    .row {
        overflow-x: auto;
    }

    .sql {
        //display: block;
        overflow-x: auto;
        max-width: 1px;

        white-space: nowrap;

        .sql-cont {
            max-width: 100%;
            //max-width: 500px;

            word-break: break-word;
            overflow-x: auto;
        }
    }


`;
